import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { SeoHead } from '../SeoHead/SeoHead';
import styles from './Layout.module.css';

export function Layout() {
  return (
    <div className={styles.root}>
      <SeoHead />
      <Navbar />
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
